module.exports = __webpack_public_path__ + "08_mustache_grey.020ba3ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer3/08_mustache_grey.png
// module id = Diqy
// module chunks = 0